/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { Container, makeStyles } from '@material-ui/core';

import IconClose from '../../assets/images/ic-close-round.svg';

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: '#FFF',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    bottom: '0px',
    boxShadow: 'rgb(0 0 0 / 35%) 0px 5px 15px',
    padding: '24px 0px 36px',
    position: 'fixed',
    transition: 'all 0.1s',
    width: '100%',
    zIndex: 500,
  },
  containerClose: {
    transform: 'translateY(100%)',
  },
  containerOpen: {
    transform: 'translateY(0%)',
  },
  iconClose: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
  iconContainer: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}));

export default ({ children, isOpen, onClose, className }) => {
  const classes = useStyles();

  const handleClose = () => {
    if (onClose) onClose();
  };

  const containerClass = isOpen ? classes.containerOpen : classes.containerClose;

  return (
    <div className={`${classes.container} ${containerClass} ${className}`}>
      <Container>
        <div style={{ position: 'relative' }}>
          {children}
          <div className={classes.iconContainer}>
            <img onClick={handleClose} src={IconClose} className={classes.iconClose} alt="Close Icon" />
          </div>
        </div>
      </Container>
    </div>
  );
};
